<template>
  <div
      v-if="supplierOrder"
      class=" flex justify-between ml-6 cursor-default select-none"
  >
    <div class="flex flex-col">
      <div class="flex gap-x-2">
          <span
              v-if="supplierOrder.reference"
              class="flex-shrink-0 cursor-default select-none rounded-md border border-theme-faded p-1 mb-1 text-sm font-extrabold text-gray-700"
          >
            {{ supplierOrder.reference }}
          </span>
        <span class="text-2xl text-gray-700 font-bold">{{ supplierOrder?.recipient?.name }}</span>
      </div>
    </div>
    <div class="flex">
      <div v-if="!open" class="flex">
        <div class="flex font-light text-slate-300">
          <div class="h-6 w-6 bg-primary text-white text-xxs font-bold rounded-full flex items-center justify-center">
            {{ supplierOrder.supplier_order_items_count }}
          </div>
        </div>
        <div>
          <div
              :class="`ml-1 flex flex-row items-center gap-2 border border-theme-${supplierOrderStatus.bg_color} px-2 rounded`">
                <span
                    :data-tint="supplierOrderStatus.bg_color"
                    class="h-3 w-3 flex-shrink-0 rounded-sm bg-gradient-to-br from-primary-400 to-primary-600"
                >&nbsp;</span
                >
            <span class="text-sm"> {{
                  supplierOrderStatus.name
                }}</span>
          </div>
        </div>
      </div>
      <div v-else >
        <div class="flex gap-x-1">
          <BaseButton
            class="hidden"
            icon="paper-plane"
            size="extra-small"
            @click="$emit('receive-order', supplierOrder)"
          />
          <BaseButton
            icon="file-pdf"
            color="danger"
            size="extra-small"
            :display-loader="load"
            @click="processDownloadSupplierOrderFile()"
          />
          <BaseButton
            v-if="['SEN', 'PAR_REC', 'REC', 'TRAN'].includes(supplierOrder.status)"
            :title="$t('global.receive_order')"
            icon="file-lines"
            size="extra-small"
            @click="$emit('receive-order', supplierOrder)"
          />
          <BaseButton
            v-if="supplierOrder.status === 'DRA'"
            icon="pen"
            size="extra-small"
            @click="$emit('edit')"
          />
          <BaseButton
            v-if="supplierOrder.status === 'DRA'"
            icon="plus"
            size="extra-small"
            color="warning"
            @click="$emit('openCategoryModal')"
          />
          <BaseButton
            v-if="!orderFromDossiers"
            icon="trash"
            size="extra-small"
            color="danger"
            @click="$emit('delete')"
          />
        </div>
      </div>
      <div
          class="ml-4 flex-shrink-0 cursor-pointer"
          @click="$emit('toggleOpen')"
      >
        <FontAwesomeIcon :icon="['fal', 'chevron-down']" size="lg"/>
      </div>
    </div>
  </div>
  <div  v-if="supplierOrder" class=" flex justify-between ml-6 cursor-default select-none">
    <div class="flex flex-col">
      <div class="flex items-center gap-x-4">
        <div class="h-5 w-5" :class="errorAvatar ? 'mb-1' : ''">
          <img
              :src="supplierOrder?.funeral_home?.logo_url"
              alt=""
              @error="handleImageError"
          />
          <BaseAvatar
              v-if="errorAvatar"
              :initials="supplierOrder?.funeral_home?.initials"
              size="extra-small"
          />
        </div>
        <p class="-ml-2 text-sm">
          {{ supplierOrder?.funeral_home?.name }}
        </p>
      </div>
      <div class="flex flex-col text-sm text-gray-500">
        <div
            v-if="supplierOrder.delivery_model.name"
            class="cursor-default select-none font-medium text-gray-500"
        >
          <FontAwesomeIcon :icon="['fal', 'location-dot']" class="w-6"/>
          <span class="ml-2 font-light text-slate-300">{{
                supplierOrder?.delivery_model.name
              }}</span>
        </div>
        <div v-if="supplierOrder.delivery_date_time" class="cursor-default select-none font-medium text-gray-500">
          <FontAwesomeIcon :icon="['fal', 'truck-clock']" class="w-6"/>
          <span class="ml-2 font-light text-slate-300">{{
                formattedDeliveryDate
              }}</span>
        </div>
      </div>
    </div>
  </div>
  <hr v-if="!open">
</template>
<script>
import {mapActions} from 'vuex'
import BaseAvatar from "@c/Avatar/BaseAvatar.vue"
import BaseButton from "@c/addf-package/components/BaseButton/BaseButton.vue"
import moment from "moment";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  name: 'SupplierOrderHeaderCardComponent',
  components: {FontAwesomeIcon, BaseAvatar, BaseButton},
  props: {
    open: {
      type: Boolean,
      required: true
    },
    supplierOrder: {
      type: Object,
      required: true
    },
    supplierOrderStatus: {
      type: Object,
      required: true
    }
  },
  emits: ['toggleOpen', 'edit', 'openCategoryModal', 'delete', 'receive-order'],
  data() {
    return {
      errorAvatar: false,
      load: false
    }
  },
  computed: {
    formattedDeliveryDate() {
      if (!this.supplierOrder?.delivery_date_time) return null
      return moment(this.supplierOrder.delivery_date_time).format('DD/MM/YYYY')
    },
    orderFromDossiers() {
      return this.supplierOrder?.supplierOrderItems?.some(item => item?.dossiers && item.dossiers.length > 0);
    }
  },
  methods: {
    ...mapActions({
      processExportSupplierOrderPDFAction: 'supplierOrder/exportSupplierOrderPDF'
    }),
    handleImageError() {
      this.errorAvatar = true
    },
    processDownloadSupplierOrderFile() {
      this.load = true
      this.processExportSupplierOrderPDFAction({id: this.supplierOrder.id})
        .then((response) => {
          if (response.message) {
            this.$h.toastInfo(response.message)
          }
          if (response.url) {
            window.open(response.url, '_blank');
            // this.$h.downloadURI(response.url, '_blank')
            this.$emit('close', false)
          }
        })
        .finally((_) => {
          this.load = false
        })
    }
  },
}
</script>
